var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('FilterMenu',{attrs:{"col":_vm.value}}),(_vm.canCreateCustomView && _vm.hasFilteredTags)?_c('SaveFilteredView',{attrs:{"view":_vm.customView}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }